import { AccountResource, useOrderExchangeBalanceForCurrencyCommon } from '@eih-netbroker/common';
import { useResource, useResourceHeaders } from '../../../../shared/services/useResource';

type UseLoadBalanceForCurrencyOutput = ReturnType<typeof useOrderExchangeBalanceForCurrencyCommon>;

export const useLoadBalanceForCurrency = (): UseLoadBalanceForCurrencyOutput => {
  const accountResource = useResource(AccountResource);
  const { getResourceHeaderWithTokenForAccount } = useResourceHeaders();

  return useOrderExchangeBalanceForCurrencyCommon({
    accountResource,
    getResourceHeaderWithTokenForAccount,
  });
};
